import sabApi from '@/api/sab'

const state = {
  accountId: null,
  credentialKey: null,
  isProfileLoaded: false,
  isSubscribed: false,
  subscription: {},
  signedInPlatform: null
}

function getCredential(credentials) {
  return credentials.filter(it => it.kind === 'email_password')[0].email
}

const getters = {}

const actions = {
  async verifyProfile({ commit }) {
    try {
      const account = await sabApi.verifyProfile()
      const subscription = await sabApi.subscriptionsStatus()
      const user = await sabApi.getUser()

      const userData = {
        ...account,
        ...subscription,
        ...user,
        account,
        subscription,
        user
      }

      commit('SET_USER_PROFILE', userData)
      commit('SET_PROFILE_LOADED', true)
    } catch {}
  },
  unset({ commit }) {
    commit('SET_USER_PROFILE', null)
    commit('SET_PROFILE_LOADED', false)
  }
}

const mutations = {
  SET_USER_PROFILE(state, userData) {
    if (!userData) {
      state.isSubscribed = false
      state.signedInPlatform = null
      state.accountId = null
      state.credentialKey = null
      state.subscription = {}
      return
    }

    state.accountId = userData.user_id
    state.signedInPlatform = userData.platform
    state.credentialKey = getCredential(userData.credentials)

    state.isSubscribed = userData.has_access
    state.subscription = userData.subscription
    state.userData = userData
  },
  SET_PROFILE_LOADED(state, isProfileLoaded) {
    state.isProfileLoaded = isProfileLoaded
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
